'use client';

import { ReactNode, Fragment } from 'react';
import { motion } from 'framer-motion';

const transition = { duration: 1, ease: [0.25, 0.1, 0.25, 1] };
const variants = {
  hidden: { filter: 'blur(10px)', transform: 'translateY(20%)', opacity: 0 },
  visible: { filter: 'blur(0)', transform: 'translateY(0)', opacity: 1 },
};

type Props = {
  className?: string;
  title?: string;
  text?: string | string[];
  children?: ReactNode;
};

export default function SectionHeader({
  className,
  title,
  text,
  children,
}: Readonly<Props>) {
  const words = title ? title.split(' ') : [];

  return (
    <motion.div
      initial="hidden"
      animate="visible"
      transition={{ staggerChildren: 0.04 }}
      className={className || ''}>
      {title && (
        <motion.h1
          //   animate={transition}
          //   variants={variants}
          className="dark:text-copper relative max-w-3xl font-serif text-4xl leading-tight tracking-tight lg:text-5xl">
          {/* {title} */}
          {words.map((word, index) => (
            <Fragment key={index}>
              <motion.span
                className={`inline-block`}
                animate={transition}
                variants={variants}>
                {word}
              </motion.span>
              {index < words.length - 1 && ' '}
            </Fragment>
          ))}
        </motion.h1>
      )}
      {text && (
        <motion.p
          animate={transition}
          variants={variants}

          className="mt-4 text-xl font-light lg:max-w-2xl lg:text-2xl">
          {text}
        </motion.p>
      )}
      {children && (
        <motion.div animate={transition} variants={variants}>
          {children}
        </motion.div>
      )}
    </motion.div>
  );
}
